import { PledgeTransactionTypeEnum } from '@tassat/common-definitions';
import { FormModal } from '@tassat/modal';
import { convertToNumber } from '@tassat/utility';
import React from 'react';

import Worker from 'Lib/worker/PrimusWorker';
import { useAppSelector } from 'Reducers/store/hooks';
import { getSecurityCurrencyPairBySecurityTicker } from 'Selectors/assets';
import { getPledgeDetail, getUserId } from 'Selectors/common';

import ReleaseForm from './releaseForm/releaseForm';
import { IReleaseFormValues, ReleasePledgeRequest } from './releaseForm/types';
import { PledgeContextWorkflowContext } from '../../../pledgeContextWorkflow';
import { ModalComponentProps } from '../../types';

function Release(props: ModalComponentProps) {
    const { pledgeContextWorkflowState, dispatchPledgeContextWorkflowAction } = React.useContext(PledgeContextWorkflowContext)!;
    const { selectedPledge } = pledgeContextWorkflowState;
    const pledgeDetail = useAppSelector(getPledgeDetail);

    const userId = useAppSelector(getUserId);
    const assetPair = useAppSelector((state) => getSecurityCurrencyPairBySecurityTicker(state, selectedPledge?.Ticker));

    const handleClose = () => {
        dispatchPledgeContextWorkflowAction({
            type: 'CHANGE_MODAL_SCREEN',
            payload: { screen: 'details' }
        });
    };

    const handleRelease = async (values: IReleaseFormValues) => {
        if (!pledgeDetail || !assetPair.security?.Ticker) return;
        try {
            const AssetQuantity = convertToNumber(values?.AssetAmount);
            const releasePledgeRequestValues: ReleasePledgeRequest = {
                UserId: userId,
                PledgeId: pledgeDetail.PledgeId,
                PledgeeAccount: pledgeDetail.PledgeParticipant[0]?.PledgeParticipantAccountAddress,
                AssetQuantity,
                Ticker: assetPair.security.Ticker,
                ApprovalNeeded: props.approvalNeeded
            };

            dispatchPledgeContextWorkflowAction({
                type: 'SET_MODAL_PLEDGE_VALUES',
                payload: {
                    PledgeId: releasePledgeRequestValues.PledgeId,
                    AssetQuantity: releasePledgeRequestValues.AssetQuantity,
                    Ticker: releasePledgeRequestValues.Ticker,
                    PledgeParticipant: pledgeDetail.PledgeParticipant
                }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_TYPE',
                payload: PledgeTransactionTypeEnum.release
            });
            dispatchPledgeContextWorkflowAction({
                type: 'CHANGE_MODAL_SCREEN',
                payload: { screen: 'details' }
            });
            dispatchPledgeContextWorkflowAction({
                type: 'SET_PLEDGE_ACTION_IN_PROGRESS',
                payload: true
            });
            await Worker.getInstance()
                .releasePledgeRequest(releasePledgeRequestValues);
        } catch (error) {
            console.error(error);
        }
    };

    const formData = {
        pledge: pledgeDetail,
        assetPair,
        handleRelease
    };

    return (
        <FormModal
            Form={ReleaseForm}
            formProps={formData}
            formType='actionForm'
            modalWidth='40%'
            onClose={handleClose}
            open
            title='Release'
        />
    );
}

export { Release };